const methods = {
  getSeatChange(item) {
    const gains = item.gains ? item.gains : 0
    const losses = item.losses ? item.losses : 0
    return gains - losses
  },
  getSeatChangeColor(e) {
    let value = null;
    if (typeof e === 'string') {
      value = parseFloat(e)
    } else {
      value = e
    }
    if (value < 0) {
      return 'rgba(250, 0, 51, 0.7)'
    } else if (value > 0) {
      return 'rgba(46, 203, 148, 0.7)'
    } else {
      return 'rgba(204, 204, 204, 0.7)'
    }
  }
}

export default {
  methods
}
